import React from 'react';
import { observer } from 'mobx-react';

import { CollapseButton } from './collapse-button';
import { CompareStore, MAX_AMOUNT_ALLOWED } from '../../stores/CompareStore';
import { SimpleButton } from '../simple-button/SimpleButton';
import { ProductCompareCard } from './product-compare-card/ProductCompareCard';
import { Spinner } from '../spinner';
import { routeNaming, AppLink } from '../../routes';
import styles from './CompareSection.css';

class CompareSection extends React.Component {
  static toggleCollapse() {
    CompareStore.toggleCollapse();
  }

  static removeProduct(productId) {
    CompareStore.removeProduct(productId);
  }

  static removeAllProducts() {
    CompareStore.removeAllProducts();
  }

  render() {
    const compareDisabled = (CompareStore.products !== null &&
      CompareStore.products.length !== MAX_AMOUNT_ALLOWED) || (CompareStore.invalidComparison);
    const showCollapsed = CompareStore.sectionCollapsed;
    const collapsedClass = showCollapsed ? styles.collapsed : '';
    const numberOfProducts = CompareStore.products.length;
    let productText = 'producto';
    if (numberOfProducts > 1) {
      productText += 's';
    }
    const productsIds = CompareStore.products.map(item => item.id);
    // Don't show compare section if there are no products to compare
    if (numberOfProducts === 0) {
      return null;
    }
    return (
      <div className={[styles.container, collapsedClass].join(' ')}>
        <div className={styles.internalContainer}>
          {
            showCollapsed
            ? (
              <span className={styles.collapsedText}>
                {numberOfProducts} {productText} para comparar
              </span>
              )
            : (
              <div className={styles.mainExpandedContainer}>
                <div className={styles.productsContainer}>
                  {
                    !!CompareStore.products &&
                    !!CompareStore.products.length &&
                    CompareStore.products.map(product => (
                      <ProductCompareCard
                        key={product.id}
                        product={product}
                        onDeletionClick={CompareSection.removeProduct}
                        className={styles.productCard}
                      />
                    ))
                  }
                </div>
                {
                  CompareStore.validatingComparison &&
                  <Spinner
                    className={styles.spinnerClass}
                    imgClassName={styles.imgSpinnerClass}
                  />
                }
                {
                  !CompareStore.validatingComparison &&
                  !CompareStore.validationError &&
                  <div className={styles.actionContainer}>
                    <div className={styles.compareContainer}>
                      <AppLink
                        routeName={routeNaming.COMPARE}
                        queryParams={{
                          q: JSON.stringify(productsIds.slice()),
                        }}
                      >
                        <SimpleButton
                          disabled={compareDisabled}
                          className={styles.compareButton}
                        >
                          Comparar
                        </SimpleButton>
                      </AppLink>
                      {
                        CompareStore.invalidComparison &&
                        <span className={styles.error}> Los productos no son comparables </span>
                      }
                    </div>
                    <button
                      className={styles.removeAll}
                      onClick={CompareSection.removeAllProducts}
                    >
                      Borrar todos
                    </button>
                  </div>
                }
                {
                  !CompareStore.validatingComparison &&
                  CompareStore.validationError &&
                  <span className={styles.error}>
                    Ha ocurrido un error, por favor intente nuevamente.
                  </span>
                }
              </div>
            )
          }
          <div className={styles.lastContainer}>
            <CollapseButton
              collapsed={showCollapsed}
              onClick={CompareSection.toggleCollapse}
            />
          </div>
        </div>
      </div>
    );
  }
}

const ObservableCompareSection = observer(CompareSection);

export { ObservableCompareSection as CompareSection };



// WEBPACK FOOTER //
// ./src/common/compare-section/CompareSection.jsx